import { api } from ".."

// funcao para cadastrar tipos
const TypesService = async (description: string, page: number) => {

    const response = await api.get('types', {
        params: {
            description, page
        }
    });

    return response;

}
// funcao para cadastrar tipos

// funcao para cadastrar tipo
const CreateTypeService = async (description: string) => {

    const response = await api.post('types', {
        description
    });

    return response;

}
// funcao para cadastrar tipo

// função para desativar/ativar tipo
const DeleteTypeService = async (id: number) => {

    const response = await api.delete(`types/${id}`);

    return response;

}
// função para desativar/ativar tipo

export {
    TypesService,
    CreateTypeService,
    DeleteTypeService
}